<div class="grid-wrapper" [class.grid-wrapper-disabled]="disabled">
    <ag-grid-angular #grid   
        [class.ag-theme-balham]="compact"     
        [class.ag-theme-quartz]="!compact"     
        [rowData]="_data?.rows"
        [pinnedBottomRowData]="!_readOnly && allowAddRow ? pinnedBottomRows : null"               
        [columnDefs]="colDefs"
        [animateRows]=false
        [getRowId]="_data?.useRowIds ? getRowId : undefined"
        [context]="context"
        [localeText]="_SmTable2Component.locale"
        [rowSelection]="{ mode: multiSelection ? 'multiRow' : 'singleRow', checkboxes: false, enableClickSelection: true }"
        [getRowClass]="getRowClass"
        [autoSizeStrategy]="horizontalScroll ? undefined : autoSizeStrategy"
        [components]="components"
        [enableCellTextSelection]="allowCellTextSelection"
        [domLayout]="autoHeight ? 'autoHeight' : undefined"
        [tooltipShowDelay]=500
        [rowDragManaged]="_allowRowDrag"
        [tabToNextCell]="tabForSameRow ? tabToNextCellBound : undefined"
        overlayLoadingTemplate="<span></span>"
        (cellKeyDown)="cellKeyDown($event)"
        (cellMouseOver)="cellMouseOver($event)"
        (cellMouseOut)="cellMouseOut($event)"
        (cellClicked)="cellClicked($event)"
        (rowDoubleClicked)="rowDoubleClicked($event)"
        (cellEditingStarted)="cellEditingStarted($event)"
        (cellEditingStopped)="cellEditingStopped($event)"
        (cellFocused)="cellFocused($event)"
        (rowSelected)="rowSelected($event)"
        (rowDragEnd)="rowDragEnd($event)"
        (selectionChanged)="selectionChanged($event)"
        (cellValueChanged)="cellValueChanged($event)"
        (sortChanged)="sortChanged($event)"
        [rowNumbers]="isEnterprise && displayRowNumbers"
        [sideBar]="isEnterprise && displaySideBar"
    >
    <!--  [stopEditingWhenCellsLoseFocus]=true -->
    </ag-grid-angular>
    <div *ngIf="disabled" class="grid-overlay"></div>
</div>